export class GetSaasEntityIdByExternalIdRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "SaasEntityType",
            "format": ""
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetSaasEntityIdByExternalIdRequest.attributeTypeMap;
    }
    constructor() {
    }
}
